import { gql } from '@apollo/client'

export const FOLLOW_ARTIST = gql`
  mutation FollowArtist($id: ID!) {
    followArtist(input: { id: $id }) {
      ... on FollowArtistSuccess {
        artist {
          id
        }
      }

      ... on FollowArtistFailure {
        errorMessage
      }
    }
  }
`
export const UNFOLLOW_ARTIST = gql`
  mutation UnfollowArtist($id: ID!) {
    unfollowArtist(input: { id: $id }) {
      ... on FollowArtistSuccess {
        artist {
          id
        }
      }
      ... on FollowArtistFailure {
        errorMessage
      }
    }
  }
`
export const FOLLOW_ARTIST_BULK = gql`
  mutation followArtistBulk($input: FollowArtistBulkInput!) {
    followArtistBulk(input: $input) {
      __typename
      ... on FollowArtistBulkSuccess {
        success
      }
      ... on FollowArtistBulkFailure {
        errorMessage
      }
    }
  }
`
